import { render } from "./DialogBanner.vue?vue&type=template&id=081f96ae"
import script from "./DialogBanner.vue?vue&type=script&lang=js"
export * from "./DialogBanner.vue?vue&type=script&lang=js"

import "./DialogBanner.vue?vue&type=style&index=0&id=081f96ae&lang=css"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QIcon});
